import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, Newspaper } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  eyebrow: "Culture scientifique",
  title: "Activités d'animation scientifique",
  banner_image: "/media/museum-events.jpg",
  intro:
    "Retrouvez ici les colloques, ateliers, conférences et journées scientifiques organisés par les Bibliothèques et Musées de l'UNISIC.",
};

export default function ActivitesAnimation() {
  const [content, setContent] = useState(DEFAULTS);
  const [news, setNews] = useState([]);
  useEffect(() => {
    api.get("/content/bm.activites_animation").then((r) => setContent({ ...DEFAULTS, ...(r.data || {}) })).catch(() => {});
    api.get("/news?limit=20").then((r) => setNews(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="activites-animation-page">
      <section className="relative h-[42vh] min-h-[300px] overflow-hidden">
        <img src={content.banner_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-veil" />
        <div className="relative h-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-12">
          <div className="eyebrow" style={{ color: "#E5C158" }}>{content.eyebrow}</div>
          <h1 className="mt-3 text-white text-4xl sm:text-5xl font-bold tracking-tight">{content.title}</h1>
          <p className="mt-3 text-white/85 max-w-3xl">{content.intro}</p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-unisic-gold" />
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        {news.length === 0 ? (
          <div className="text-center py-20 paper-card p-10">
            <Newspaper className="w-8 h-8 text-slate-300 mx-auto" />
            <p className="mt-4 text-slate-500 text-sm">Aucune activité publiée pour l'instant.</p>
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {news.map((n) => (
              <Link key={n.id} to={`/actualites/${n.id}`} className="paper-card card-hover overflow-hidden flex flex-col" data-testid={`activite-${n.id}`}>
                {n.image_url && <img src={n.image_url} alt="" className="w-full h-44 object-cover" />}
                <div className="p-5 flex-1 flex flex-col">
                  <div className="text-[11px] uppercase tracking-widest text-unisic-gold font-semibold flex items-center gap-2">
                    <Calendar className="w-3 h-3" /> {n.published_at ? new Date(n.published_at).toLocaleDateString("fr-FR") : ""}
                  </div>
                  <h3 className="mt-2 font-display font-semibold text-unisic-blue leading-snug">{n.title}</h3>
                  {n.excerpt && <p className="mt-2 text-sm text-slate-600 line-clamp-3 flex-1">{n.excerpt}</p>}
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
